import { render, staticRenderFns } from "./CustomerAddressEdit.vue?vue&type=template&id=ca9fe226&"
import script from "./CustomerAddressEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports